import React, { useEffect, useContext } from "react";
import { StoreContext } from "../../Context/StoreContext";
import Carousel from "react-multi-carousel";
import Previous from "../../VibehutUI/Icons/Previous";
import Next from "../../VibehutUI/Icons/Next";
import LiveConversationCard from "./LiveConversationCard";
import { getActiveConversations } from "../../services/rooomService";
import { useState } from "react";

function LiveConversations({ sliderWidth }) {
  const { state } = useContext(StoreContext);
  const [conversations, setConversations] = useState([]);
  const { auth } = state;
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 769 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 768, min: 641 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 640, min: 0 },
      items: 1,
    },
  };

  const getActiveConversationsFun = async () => {
    await getActiveConversations(auth?.user?.token)
      .then((res) => {
        setConversations(res.data);
      })
      .catch((err) => {
        setConversations([]);
        console.log("err", err);
      });
  };
  useEffect(() => {
    getActiveConversationsFun();

    const interval = setInterval(() => getActiveConversationsFun(), 10000);

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const ButtonGroup = ({ next, previous, goToSlide, ...rest }) => {
    const {
      carouselState: { currentSlide },
    } = rest;
    return conversations?.length > 3 ? (
      <div className="absolute right-1 top-12">
        <span className="flex space-x-3">
          <span onClick={() => previous()} className="cursor-pointer">
            <Previous disabled={currentSlide === 0} />
          </span>

          <span onClick={() => next()} className="cursor-pointer">
            <Next />
          </span>
        </span>
      </div>
    ) : (
      <></>
    );
  };

  return (
    <>
      {conversations?.length > 0 && (
        <div className="relative" style={{ width: sliderWidth }}>
          <div className="pt-8">
            <div className="px-2">
              <p className="font-bold md:text-2xl text-xl text-darkNight dark:text-frescoWhite">
                Join the Conversation
              </p>
              <p className="text-lg text-darkGray">Chat with others now</p>
            </div>

            <div className="pt-7 ">
              <div className="hidden md:block">
                <Carousel
                  responsive={responsive}
                  renderButtonGroupOutside={true}
                  itemClass="px-2.5"
                  arrows={false}
                  shouldResetAutoplay={false}
                  customButtonGroup={<ButtonGroup />}
                >
                  {conversations.map((item, index) => (
                    <>
                      {item.users.length > 0 && (
                        <div key={index + item.room._id}>
                          <LiveConversationCard conversation={item} />
                        </div>
                      )}
                    </>
                  ))}
                </Carousel>
              </div>
              <div className="md:hidden flex flex-col gap-4">
                {conversations.map((item, index) => (
                  <>
                    {item.users.length > 0 && (
                      <div key={index + item.room._id}>
                        <LiveConversationCard conversation={item} />
                      </div>
                    )}
                  </>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default LiveConversations;
